import * as React from "react";
const SvgSparkle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1Q9.8 6.2 15 8Q9.8 9.8 8 15Q6.2 9.8 1 8Q6.2 6.2 8 1Z", fill: "currentColor" }));
export default SvgSparkle;
